/* @jsx h */
import { defineComponent, ref, h } from "vue";
import { LemmonModal } from "@lemmonhq/uikit";
import { RawPayment } from "@lemmonhq/types";
import { useLocalization } from "@lemmonhq/uikit";

interface EditPaymentModalProps {
  onClose: () => void;
  payment: RawPayment;
  onSubmit: (
    guid: string,
    data: {
      payment_method: string;
    },
  ) => Promise<void>;
}

export const EditPaymentModal = defineComponent<EditPaymentModalProps>({
  name: "EditPaymentModal",
  props: ["onClose", "onSubmit", "payment"],
  setup(props) {
    const paymentMethod = ref(props.payment.method);
    const loading = ref(false);

    const handleSubmit = async () => {
      try {
        loading.value = true;
        await props.onSubmit(props.payment.guid, {
          payment_method: paymentMethod.value,
        });
      } catch (e) {
      } finally {
        loading.value = false;
      }
    };
    const { t } = useLocalization();
    return () => (
      <LemmonModal
        title={t("reports.tx.change_payment.title")}
        onClose={() => {
          console.log("closing");
          props.onClose();
        }}
      >
        <div class="p-6 space-y-4">
          <div>
            <label class="form-control w-full">
              <div class="label">
                <span class="label-text text-accent">
                  {t("reports.tx.change_payment.payment_method")}
                </span>
              </div>
              <select
                class="select select-bordered w-full"
                value={paymentMethod.value}
                onChange={(e) =>
                  (paymentMethod.value = (e.target as HTMLSelectElement)
                    .value as "cash" | "card" | "manual")
                }
              >
                <option value="cash">{t("general.words.cash")}</option>
                <option value="card">{t("general.words.card")}</option>
                <option value="manual">{t("general.words.manual")}</option>
              </select>
            </label>
          </div>

          <div class="flex justify-end gap-2">
            <button class="btn btn-ghost" onClick={props.onClose}>
              {t("general.words.cancel")}
            </button>
            <button
              class="btn btn-primary"
              onClick={handleSubmit}
              disabled={!paymentMethod.value || loading.value}
            >
              {t("reports.tx.change_payment.change_payment_button")}
            </button>
          </div>
        </div>
      </LemmonModal>
    );
  },
});
